import * as React from "react";
import EndpointContext from "../context/EndpointContext";
import { LineRating, EndpointContextProps } from "../types";

interface EndpointsExtension {
  endpoints: EndpointContextProps;
}

interface MessageControlsProps {
  onChangeRating: (rating: LineRating) => void;
  rating: LineRating;
}

class MessageControls extends React.Component<
  MessageControlsProps & EndpointsExtension,
  {}
> {
  onClickThumbsUp() {
    this.updateRating(LineRating.Positive);
  }

  onClickThumbsDown() {
    this.updateRating(LineRating.Negative);
  }

  updateRating(newRating: LineRating) {
    if (this.props.rating === newRating) {
      newRating = LineRating.Unset;
    }

    this.setState({
      rating: newRating
    });

    this.props.onChangeRating(newRating);
  }

  getThumbRatingClass(thumbRating: LineRating) {
    if (this.props.rating !== thumbRating) {
      return "";
    }

    return "selected-thumb";
  }

  render() {
    return (
      <div className="message-controls" aria-hidden="true">
        <span
          className="message-control-left"
          onClick={() => this.onClickThumbsUp()}
          role="button"
        >
          <img
            className={this.getThumbRatingClass(LineRating.Positive)}
            src={`${this.props.endpoints.images}/inline/thumbs_up.png`}
            alt=""
            role="presentation"
          />
        </span>
        <span
          className="message-control-right"
          onClick={() => this.onClickThumbsDown()}
          role="button"
        >
          <img
            className={this.getThumbRatingClass(LineRating.Negative)}
            src={`${this.props.endpoints.images}/inline/thumbs_down.png`}
            alt=""
            role="presentation"
          />
        </span>
      </div>
    );
  }
}

export default (props: MessageControlsProps) => (
  <EndpointContext.Consumer>
    {endpoints => <MessageControls endpoints={endpoints} {...props} />}
  </EndpointContext.Consumer>
);
